/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { View } from '@components/atoms'

interface StatusIndicatorProps {
	status: 'pending' | 'completed'
	className?: string
}

export const StatusIndicator = ({ status, className }: StatusIndicatorProps) => {
	return (
		<View
			css={[
				style.statusIndicator,
				status === 'completed' ? style.activeStatus : style.inactiveStatus,
			]}
			className={className}
		/>
	)
}

const style = {
	statusIndicator: css`
		width: '4px';
		height: '100%';
		background-color: '#D1D5DB';
		border-radius: '4px';
	`,
	activeStatus: css`
		background-color: #d1fae5 !important;
		color: #059669;
	`,
	inactiveStatus: css`
		background-color: #fee2e2 !important;
		color: #dc2626;
	`,
}
